import { Col, Row } from "react-bootstrap";
import { Button, RadioButton, RadioGroup, Select, TextBox } from "@veneer/core";
import "./profile.scss";
import { useCallback, useEffect, useState } from "react";
import { ViewProfile } from "./view-profile";
import { getCountry, getValidatedNumberInput, onSearchDropDown } from "../../../../utils";
import {
  validateField,
  validateForm,
} from "../../../../form-validation/form-Validation";
import { profileTextBox } from "../../../../form-validation/form-field-name";
import { useLocation } from "react-router-dom";
import {
  POST_BIND_LANGUAGE,
  POST_CONTACT_SAVE,
  POST_PROFILE_PAGE_LOAD,
} from "../../../../services";
import { apiPost } from "../../../../services/service";
import Loader from "../../shared-components/loader/loader";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";
import { POST_PROFILE_ACCOUNT_NAME_CHANGE } from "@constants/end-points";
export interface OptionType {
  label: string;
  value: string;
}

interface State {
  [key: string]: string;
}

interface FormStateType {
  [key: string]: any;
}

export const Profile = () => {
  const [openPopup, setOpenPoup] = useState(false);
  const [formState, setFormState] = useState<FormStateType>(profileTextBox);
  const [errorState, setErrorState] = useState<State>({});
  const [countryNcode, setCountryNcode] = useState<any>();
  const [codeAll, setCodeAll] = useState<any>();
  const [profilePageLoad, setProfilePageLoad] = useState<any>();
  const [userData, setUserData] = useState<any>();
  const [userObj, setUserObj] = useState<any>();
  const [languageList, setLanguageList] = useState<any>();
  const [timeZoneList, setTimeZoneList] = useState<any>();
  const [pinList, setPinList] = useState<any>();
  const [companyList, setCompanyList] = useState<any>();
  const [countryList, setCountryList] = useState<any>();
  const [filteredLanguage, SetFilteredLanguages] = useState<any>();
  const location = useLocation();
  const [progress, setProgress] = useState(false);
  const [optInOptOut, setOptInOptOut] = useState<boolean | null>(null);
  const [nonRequiredField, setNonRequiredField] = useState<FormStateType>();
  const [showALTName, seALTName] = useState(false);
  const [filteredCountryList, setFilteredCountryList] = useState<any>();
  const [isUpdated, setUpdated] = useState(false);
  const { t } = useTranslation();
  const individualOrCompany: boolean =
    (window as any).IsIndividualRole ||
      window.location.hostname.includes("localhost")
      ? true
      : false;
  const [popupTilte, setPopupTitle] = useState<string>("");
  const [open, setOpen] = useState(false);

  const [bindPinList, setBindPinList] = useState<any>();


  const popupHeader = () => {
    return (
      <p className="popup-header">
        <img
          src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
          alt=""
          style={{ height: "46px", width: "auto" }}
        />
        <span>{popupTilte}</span>
      </p>
    );
  };

  const handleCallBack = (title: string) => {
    setPopupTitle(title);
    setOpen(true);
  };

  const pageLoadFetch = async () => {
    try {
      const payload = {
        tabid: "myProfile",


      };
      let country: any = await getCountry();
      //setCountryNcode(country);

      setProgress(true);
      const response = await apiPost(POST_PROFILE_PAGE_LOAD, payload);
      if (response?.data) {
        const data = response?.data;
        const pageLoad = data;
        setProfilePageLoad(pageLoad);
        setUserData(JSON.parse(pageLoad?.UserData));
        setUserObj(JSON.parse(pageLoad?.UserData)?.[0]);
        let filterLang = JSON.parse(pageLoad?.filteredLanguages);
        const filteredLanguagesInfo: any[] = JSON.parse(
          pageLoad?.filteredLanguages
        )
          ? [
            { label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" },
            ...filterLang.map(({ Value, Key }: any) => ({
              label: Value,
              value: Key,
            })),
          ]
          : [];

        SetFilteredLanguages(filteredLanguagesInfo);
        const countryListInfo: any[] = JSON.parse(pageLoad?.CountryList)
          ? [
            { label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" },
            ...JSON.parse(pageLoad?.CountryList).map(
              ({ Value, Key }: any) => ({
                label: Value,
                value: Key,
              })
            ),
          ]
          : [];
        setFilteredCountryList(countryListInfo);
        setCountryList(countryListInfo);

        const codeAllList: any[] = JSON.parse(pageLoad?.CountryList)
          ? [
            { label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" },
            ...JSON.parse(pageLoad?.CountryList).map(
              ({ ShortCode, CountryCode, Key }: any) => ({
                label: `${CountryCode} ${ShortCode}`,
                value: Key,
              })
            ),
          ]
          : [];
        setCodeAll(codeAllList);
        setCountryNcode(codeAllList);

        const languageListInfo: any[] = JSON.parse(pageLoad?.LanguageList)
          ? [
            { label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" },
            ...JSON.parse(pageLoad?.LanguageList).map(
              ({ Value, Key }: any) => ({
                label: Value,
                value: Key,
              })
            ),
          ]
          : [];
        setLanguageList(languageListInfo);
        const timeZoneInfo: any[] = JSON.parse(pageLoad?.TimeZoneList)
          ? [
            { label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" },
            ...JSON.parse(pageLoad?.TimeZoneList).map(
              ({ Value, Key }: any) => ({
                label: Value,
                value: Key,
              })
            ),
          ]
          : [];
        setTimeZoneList(timeZoneInfo);

        const companyInfo: any[] = JSON.parse(pageLoad?.CompanyList)
          ? [
            { label: t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'}), value: "-1" },
            ...JSON.parse(pageLoad?.CompanyList).map(
              ({ Value, Key }: any) => ({
                label: Value,
                value: Key,
              })
            ),
          ]
          : [];

        setCompanyList(companyInfo);

          const pinInfo: any[] = JSON.parse(pageLoad?.PinList)
          ? [{label:t('HPI.PIN',{defaultValue:'Select Pin'}), value: -1},
            ...JSON.parse(pageLoad?.PinList).map(
              ({ Value, Key }: any) => ({
                label: Value,
                value: Key,
              })
            ),
          ]
          : [];

        setBindPinList(pinInfo);

        // SetFilteredLanguages(JSON.parse(pageLoad?.filteredLanguages));
        setPinList(pinInfo);
        setProgress(false);
      } else {
        setProgress(false);
      }
    } catch (error) {
      setProgress(false);
    }
  };

  useEffect(() => {
    pageLoadFetch();
  }, []);

  useEffect(() => {
    updateFormStateOnLoad(userObj);
  }, [userObj]);

  const updateFormStateOnLoad = (userObj: any) => {
    seALTName(false);
    if (userObj?.countryName === "Japan") {
      seALTName(true);
    }
    setFormState({
      ...userObj,
      firstname: userObj?.firstname,
      lastname: userObj?.lastname,
      phoneNmCountryCode: userObj?.countryId,
      phNum: userObj?.phNum.replace('+'+ userObj?.countryId.countrycode, ''),
      phNumAlternativeCountryCode: userObj?.countryId,
      phNumAlternative: userObj?.phNumAlternative.replace('+'+ userObj?.countryId.countrycode, ''),
      email: userObj?.email,
      addressline1: userObj?.addressline1,
      phCity: userObj?.phCity,
      phState: userObj?.phState,
      phZipcode: userObj?.phZipcode,
      timeZone: userObj?.timeZone,
      countryId: userObj?.countryId,
      countryShortCode: userObj?.countryShortCode,
      countryCode: userObj?.phoneNmCountryCode,
      languageId: userObj?.languageId,
      portalLanguageId: userObj?.portalLanguageId,
      languageName: userObj?.languageName,
      optInOptOut: userObj?.optInOptOut,
      timezonename: userObj?.timezonename,
      accountType: userObj?.accountType,
      parentCustomerId: userObj?.parentCustomerId,
      extension: userObj?.extension,
      extensionAlternative: userObj?.extensionAlternative,
      addressline2: userObj?.addressline2,
      addressline3: userObj?.addressline3,
      mailstop: userObj?.mailstop,
      updatedParentCustomerId: userObj?.parentCustomerId,
      updatedPinId: userObj?.updatedPinId,
    });
    setOptInOptOut(userObj?.optInOptOut === "true" ? true : false);
  };
  const handleChange = (v: any, e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormState((prevState: any) => ({
      ...prevState,
      [name]: v,
    }));

    if (['phNum', 'phNumAlternative', 'email'].includes(name)) {
      setErrorState((prevState) => ({
        ...prevState,
        [name]: '',
      }));
    } else {
      validateField(name, v, setErrorState,t);
    }

  };


  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (value) {
      validateField(name, value, setErrorState,t);
    }
  };



  const handleSelectChange = (selectedOption: any, name: any) => {
    setFormState((prevState) => ({
      ...prevState,
      [name]: selectedOption.value,
    }));
    
    if (name === "countryId") {
      setFormState((prevState) => ({
        ...prevState,
        ["countryName"]: selectedOption.label,
        ["CountryNameMyProfile"]: selectedOption.label,
        ["phoneNmCountryCode"]: selectedOption.value,
      }));

      if (selectedOption.label === "") {
      }
    }
    if (name === "timezonename") {
      setFormState((prevState) => ({
        ...prevState,
        ["timezonename"]: selectedOption.label,
        ["timeZone"]: selectedOption.value,
      }));
    }

    if (name === "portalLanguageId") {
      setFormState((prevState) => ({
        ...prevState,
        ["portalLanguageId"]: selectedOption.value,
      }));
    }
    if (name === "languageId") {
      setFormState((prevState) => ({
        ...prevState,
        ["languageName"]: selectedOption.label,
        ["languageId"]: selectedOption.value,
      }));
    }
    if (name === "parentCustomerId") {


      if( selectedOption.value !== '-1' ){
        const payload = {
          companyid : selectedOption.value,
      };
      
        fetchSiteNameInfo(payload);       
      }

      if(selectedOption.value === '-1'){
        setFormState((prevState) => ({
          ...prevState,
          ["updatedPinId"]: "-1",
          ["pinId"]: "-1" ,
          ["pinmessage"]: ""
        }));
      }


      setFormState((prevState) => ({
        ...prevState,
        ["companyName"]: selectedOption.label,
        ["parentCustomerId"]: selectedOption.value,
        ["dunsNumberDropDown"]: selectedOption.value,
        ["updatedParentCustomerId"]: selectedOption.value,
      }));
    }

      if (name === "updatedPinId") {
        setFormState((prevState) => ({
          ...prevState,
          ["updatedPinId"]: selectedOption.value,
          ["pinId"]: selectedOption.value ,
          ["pinmessage"]:selectedOption.label
        }));
       
      }


    if (name === "phNumAlternativeCountryCode") {
      setFormState((prevState) => ({
        ...prevState,
        ["phNumAlternativeCountryCode"]: selectedOption.value,
      }));
    }
    if (name === "phoneNmCountryCode") {
      setFormState((prevState) => ({
        ...prevState,
        ["phoneNmCountryCode"]: selectedOption.value,
        ["countryId"]: selectedOption.value,
      }));
    }
    validateField(name, selectedOption.value, setErrorState,t);
  };


  useEffect(()=>{
    if(bindPinList?.length === 2 ){
      setFormState((prevState) => ({
        ...prevState,
        ["updatedPinId"]: bindPinList[1].value,
        ["pinId"]: bindPinList[1].value,
        ["pinmessage"]:bindPinList[1].label
      }));
      
  }
  else if(!isUpdated && bindPinList?.length > 2){
    setFormState((prevState) => ({
      ...prevState,
      ["updatedPinId"]: -1,
      ["pinId"]:-1,
      ["pinmessage"]:-1
    }));
    setUpdated(true);
  }
  }, [bindPinList , formState['companyName']])
  const fetchSiteNameInfo = useCallback(async (payload: any) => {
    try {

      const response = await apiPost(POST_PROFILE_ACCOUNT_NAME_CHANGE, payload);
      const newBindPinData = JSON.parse(response?.data?.PinList || []) || []; // Prevent errors if response is empty


      const pinInfo: any[] = newBindPinData
      ? [{label:t('HPI.PIN',{defaultValue:'Select Pin'}), value: -1},
        ...newBindPinData.map(
          ({ Value, Key }: any) => ({
            label: Value,
            value: Key,
          })
        ),
      ] : [];

    setBindPinList(pinInfo);
    setPinList(pinInfo);

    } catch (error: any) {
      throw new Error(error.message || "Failed to fetch contact details");
    }
  }, []);


  const handleViewProfile = () => {
    setOpenPoup(true);
  };
  const closePopup = () => {
    setOpenPoup(false);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    let FormErrors = validateForm(formState, "profile",t);
    setErrorState(FormErrors);
    if (Object.keys(FormErrors).length > 0) {
      toast.error(t('HPI.ErrorMessage.FillRequiredFields',{defaultValue:'Please fill the required fields'}));
    } else {
      setProgress(true);
      let payload = {
        ...nonRequiredField,
        ...formState,
        tabid: "myProfile",


        optInOptOut: optInOptOut,
      };
      try {
        let savedata = await apiPost(POST_CONTACT_SAVE, payload);
        if (savedata.data) {
          toast.success(savedata?.data?.successmessage);
          setProgress(false);
          setUpdated(true);
          pageLoadFetch();
        } else {
          setProgress(false);
        }
      } catch (error) {
        setProgress(false);
      }
    }
  };

  const handleContryLogic = async (selectedOption: any) => {
    try {
      let payload = {
        countryId: selectedOption.value,


      };
      const getLaguage = await apiPost(POST_BIND_LANGUAGE, payload);
      if (getLaguage.data) {
        seALTName(false);
        setErrorState({});
        if (selectedOption?.label === "Japan") {
          seALTName(true);
        }
        let filteredLanguages = JSON.parse(
          getLaguage?.data?.filteredLanguages
        ).map((item: any) => ({
          label: item.Value,
          value: item.Key,
        }));
        SetFilteredLanguages([
          { label: "Select Languages", value: "-1" },
          ...filteredLanguages,
        ]);
        setFormState((prevState) => ({
          ...prevState,
          ["languageId"]: "",
        }));
        //formState["languageId"]
      } else {
      }
    } catch (error) { }
  };

  return (
    <div className="profile-form-container">
      {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
      <p className="body-regular">
        {t("HPI.Profilepage.myprofile.defaultprofile", {
          defaultValue:
            "Please fill your contact information for the case management profile. Any changes made below will only apply to this profile and not to your HP Sign-In account.",
        })}
      </p>
      <h6 className="subtitle-regular">
        {t("HPI.Profilepage.myprofile.Contact", { defaultValue: "Contact" })}
      </h6>
      <p>
        <span className="error">*</span>
        {t("HPI.Profilepage.myprofile.RequiredFields", {
          defaultValue: "Required",
        })}
      </p>

      <form
        id="Profile-settings-form"
        className="profile-form"
        onSubmit={handleSubmit}
      >
        <Row>
          <Col col={12} md={6}>
            <TextBox
              name="firstname"
              label={t("HPI.Profilepage.myprofile.Firstname", {
                defaultValue: "First name",
              })}
              placeholder={t("HPI.Profilepage.Placeholder.EnterFirstName", {
                defaultValue: "Enter first name",
              })}
              required
              className="textbox"
              separateLabel
              error={errorState["firstname"] ? true : false}
              helperText={errorState["firstname"] || ""}
              onChange={(v: any, e) => {
                handleChange(v, e);
              }}
              value={formState["firstname"]}
            />
          </Col>
          <Col col={12} md={6}>
            <TextBox
              defaultValue=""
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Lastname", {
                defaultValue: "Last name",
              })}
              placeholder={t("HPI.Profilepage.Placeholder.EnterLastName", {
                defaultValue: "Enter last name",
              })}
              required
              className="textbox"
              separateLabel
              name="lastname"
              error={errorState["lastname"] ? true : false}
              helperText={errorState["lastname"] || ""}
              onChange={(v: any, e) => {
                handleChange(v, e);
              }}
              value={formState["lastname"]} // || userObj?.lastname}
            />
          </Col>
        </Row>

        {showALTName && (
          <Row>
            <Col col={12} md={6}>
              <TextBox
                name="alternatefirstname"
                label={t("HPI.Profilepage.myprofile.alternatefirstname", {
                  defaultValue: "Alternative first name",
                })}
                placeholder={t("HPI.Profilepage.myprofile.alternatefirstname", {
                  defaultValue: "Alternative first name",
                })}
                required
                className="textbox"
                separateLabel
                error={errorState["alternatefirstname"] ? true : false}
                helperText={errorState["alternatefirstname"] || ""}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
                value={formState["alternatefirstname"]}
              />
            </Col>
            <Col col={12} md={6}>
              <TextBox
                defaultValue=""
                //helperText="Helper Text"
                label={t("HPI.Profilepage.myprofile.alternatelasttname", {
                  defaultValue: "Alternative last name",
                })}
                placeholder={t("HPI.Profilepage.myprofile.alternatelasttname", {
                  defaultValue: "Alternative last name",
                })}
                required
                className="textbox"
                separateLabel
                name="alternatelasttname"
                error={errorState["alternatelasttname"] ? true : false}
                helperText={errorState["alternatelasttname"] || ""}
                onChange={(v: any, e) => {
                  handleChange(v, e);
                }}
                value={formState["alternatelasttname"]} // || userObj?.lastname}
              />
            </Col>
          </Row>
        )}

      <Row>
          <Col lg={6} md={12}  className="phone-input-box input-container">
          <Col lg={4} md={6}>
            <div className="country-code">
              <Select
                separateLabel
                options={countryNcode ? countryNcode : []}
                label={t("HPI.ProfilePage.cs.SelectCountryCode", {
                  defaultValue: "Code",
                })}
                placement="bottom"
                className="textbox"
                helperTextVisibility="auto"
                name="phoneNmCountryCode"
                //clearIcon={false}
                error={errorState["phoneNmCountryCode"] ? true : false}
                helperText={errorState["phoneNmCountryCode"] || ""}
                onChange={(selectedOption: any) => {
                  handleSelectChange(selectedOption, "phoneNmCountryCode");
                }}
                showSearch
                onSearch={(value: any) => {
                  let filtered: any = onSearchDropDown(codeAll, value);
                  setCountryNcode(filtered);
                }}
                value={[formState["phoneNmCountryCode"]]} // || userObj?.phNumType}
                onClear={() => {
                  setFormState((prevState) => ({
                    ...prevState,
                    ["phoneNmCountryCode"]: "",
                    ["countryId"]: "",
                  }));
                }}
              />
            </div>
            </Col>
            <Col lg={8} md={6}>
            <div className="tooltip-container">
              <div className="label-container">
                <label>{t("HPI.Profilepage.myprofile.Phonenumber", {
                  defaultValue: "Phone number",
                })}
                  <span className="error">*</span>
                </label>

                <span className="supporting-text">
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() => handleCallBack(t("HPI.CreateCase.Contactinformation.Phonenumber", { defaultValue: ' Phone Number' }))}
                  >
                    <p>
                      {t("HPI.Profilepage.PhoneNumberToolTip.body", { defaultValue: "Please enter no more than 15 numerals, starting with country code do not use '+' or any other characters;" })}
                    </p>
                  </HelpModalPopup>
                </span>
              </div>




              <TextBox
                defaultValue=""
                //helperText="Helper Text"
                // label={t("HPI.Profilepage.myprofile.Phonenumber", {
                //   defaultValue: "Phone number",
                // })}
                placeholder={t("HPI.CreateCase.Placeholder.EnterPhoneNumber", {
                  defaultValue: "Enter phone number",
                })}
                required
                className="textbox"
                separateLabel
                name="phNum"
                error={errorState["phNum"] ? true : false}
                helperText={errorState["phNum"] || ""}
                onBlur={(e) => handleBlur(e)}
                onChange={(v: any, e) => {
                  const value = getValidatedNumberInput(v, 15);
                  if (value.length <= 15) {
                    handleChange(value, e);
                  }
                }}
                value={formState["phNum"]} // || userObj?.phNum}
              />



            </div>
            </Col>
          </Col>
      
          <Col lg={6} md={12} className="phone-input-box input-container">
          <Col lg={4} md={6}>
            <div className="country-code">
              <Select
                separateLabel
                options={countryNcode ? countryNcode : []}
                label={t("HPI.ProfilePage.cs.SelectCountryCode", {
                  defaultValue: "Code",
                })}
                className="textbox"
                placement="bottom"
                name="phNumAlternativeCountryCode"
                helperTextVisibility="auto"
                //clearIcon={false}
                onChange={(selectedOption: any) => {
                  handleSelectChange(
                    selectedOption,
                    "phNumAlternativeCountryCode"
                  );
                }}
                value={[formState["phNumAlternativeCountryCode"]]}
                showSearch
                onSearch={(value: any) => {
                  let filtered: any = onSearchDropDown(codeAll, value);
                  setCountryNcode(filtered);
                }}
                onClear={() => {
                  setFormState((prevState) => ({
                    ...prevState,
                    ["phNumAlternativeCountryCode"]: "",
                  }));
                }}
              />
            </div>
            </Col>
            <Col lg={8} md={6}>
            <div className="tooltip-container">
              <div className="label-container">
                <label>{t("HPI.Profilepage.myprofile.Phonenumberalternate", {
                  defaultValue: "Phone number (alternate)",
                })} </label>
                <span className="supporting-text">
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() => handleCallBack(t("HPI.CreateCase.Contactinformation.Phonenumber", { defaultValue: ' Phone Number' }))}
                  >
                    <p>
                      {t("HPI.Profilepage.PhoneNumberToolTip.body", { defaultValue: "Please enter no more than 15 numerals, starting with country code do not use '+' or any other characters;" })}
                    </p>
                  </HelpModalPopup>
                </span>
              </div>

              <TextBox
                defaultValue=""
                //helperText="Helper Text"
                // label={t("HPI.Profilepage.myprofile.Phonenumberalternate", {
                //   defaultValue: "Phone number (alternate)",
                // })}
                placeholder={t('HPI.Profilepage.Placeholder.EnterAlternatePhoneNumber',{defaultValue:'Enter alternate phone number'})}
                required
                className="textbox"
                separateLabel
                name="phNumAlternative"
                error={errorState["phNumAlternative"] ? true : false}
                helperText={errorState["phNumAlternative"] || ""}
                onChange={(v: any, e) => {
                  const value = getValidatedNumberInput(v, 15);
                  if (value.length <= 15) {
                    handleChange(value, e);
                  }
                }}
                onBlur={(e) => handleBlur(e)}
                value={formState["phNumAlternative"]} // || userObj?.phNumAlternative}
              />
            </div>
            </Col>
          </Col>
          </Row>

          <Row>
            <Col lg={6} md={12} className="input-container">
            <div className="tooltip-container">
              <div className="label-container">
                <label>{t("HPI.Profilepage.myprofile.Extension", {
                  defaultValue: "Extension",
                })}
                  <span className="supporting-text" >
                    <HelpModalPopup
                      align={"start"}
                      id={"modal-popup"}
                      show={open}
                      onClose={() => setOpen(false)}
                      title={popupHeader()}
                      callback={() => handleCallBack(t("HPI.Profilepage.exttooltip.header", { defaultValue: 'Extension code' }))}
                    >
                      <p>
                        {t("HPI.Profilepage.exttooltip.body", { defaultValue: "The extension code must contain only digits, up to a maximum length of 5." })}
                      </p>
                    </HelpModalPopup>
                  </span>

                </label>
              </div>



              <TextBox
                defaultValue=""
                //helperText="Helper Text"
                // label={t("HPI.Profilepage.myprofile.Extension", {
                //   defaultValue: "Extension",
                // })}
                placeholder={t("HPI.Profilepage.Placeholder.EnterExtension", {
                  defaultValue: "Enter extension",
                })}
                className="textbox"
                separateLabel
                name="extension"
                onChange={(v: any, e) => {
                  const value = getValidatedNumberInput(v, 5);
                  if (value.length <= 5) {
                    handleChange(value, e);
                  }
                }}
                value={formState["extension"]} // || userObj?.extension}
              />
            </div>
          </Col>
          <Col col={12} md={6} className="input-container">
            <div className="tooltip-container">
              <div className="label-container">
                <label>{t("HPI.Profilepage.myprofile.alternateExtension", {
                  defaultValue: "Extension",
                })}
                  {/* <span className="error">*</span> */}
                </label>

                <span className="supporting-text">
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() => handleCallBack(t("HPI.Profilepage.exttooltip.header", { defaultValue: 'Extension code' }))}
                  >
                    <p>
                      {t("HPI.Profilepage.exttooltip.body", { defaultValue: "The extension code must contain only digits, up to a maximum length of 5." })}
                    </p>
                  </HelpModalPopup>
                </span>
              </div>


              <TextBox
                defaultValue=""
                //helperText="Helper Text"
                // label={t("HPI.Profilepage.myprofile.alternateExtension", {
                //   defaultValue: "Extension",
                // })}
                placeholder={t("HPI.Profilepage.Placeholder.EnterExtension", {
                  defaultValue: "Enter extension",
                })}
                className="textbox"
                separateLabel
                name="extensionAlternative"
                onChange={(v: any, e) => {
                  const value = getValidatedNumberInput(v, 5);
                  if (value.length <= 5) {
                    handleChange(value, e);
                  }
                }}
                value={formState["extensionAlternative"]} // || userObj?.extensionAlternative}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col col={12} md={6} className="input-container">

            <div className="tooltip-container">
              <div className="label-container">
                <label>{t("HPI.Profilepage.myprofile.Email", {
                  defaultValue: "Email",
                })}
                  <span className="error">*</span>
                </label>
                <span className="supporting-text" >
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() => handleCallBack(t("HPI.ProfilePage.EmailTooltip.Header", { defaultValue: 'Email Address' }))}
                  >
                    <p>
                      {t("HPI.ProfilePage.EmailTooltip.Content", { defaultValue: "This field is locked and can only be modified through a support request to HP. See the MyHPSupport Help page for instructions on submitting a support request." })}
                    </p>
                  </HelpModalPopup>
                </span>


              </div>

              <TextBox
                defaultValue=""
                //helperText="Helper Text"
                // label={t("HPI.Profilepage.myprofile.Email", {
                //   defaultValue: "Email",
                // })}
                placeholder={t("HPI.Profilepage.Placeholder.EnterEmail", {
                  defaultValue: "Enter email",
                })}
                required
                className="textbox"
                separateLabel
                disabled
                name="email"
                value={formState["email"]} // || userObj?.email}
              />
            </div>
          </Col>
          <Col col={12} md={6} className="input-container">

            <div className="tooltip-container">
              <div className="label-container">
                <label>{t("HPI.Profilepage.myprofile.Confirmemail", {
                  defaultValue: "Confirm email",
                })}
                  <span className="error">*</span>
                </label>
                <span className="supporting-text">
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() => handleCallBack(t("HPI.ProfilePage.EmailTooltip.Header", { defaultValue: 'Email Address' }))}
                  >
                    <p>
                      {t("HPI.ProfilePage.EmailTooltip.Content", { defaultValue: "This field is locked and can only be modified through a support request to HP. See the MyHPSupport Help page for instructions on submitting a support request." })}
                    </p>
                  </HelpModalPopup>
                </span>
              </div>

              <TextBox
                defaultValue=""
                //helperText="Helper Text"
                // label={t("HPI.Profilepage.myprofile.Confirmemail", {
                //   defaultValue: "Confirm email",
                // })}
                placeholder={t("HPI.Profilepage.myprofile.Confirmemail", {
                  defaultValue: "Confirm email",
                })}
                required
                className="textbox"
                separateLabel
                disabled
                name="email"
                value={formState["email"]} // || userObj?.email}
              />
            </div>
          </Col>
        </Row>

        <Row>
          {individualOrCompany === false ? (
            <>
            <Col md={6} className="textbox">
              <Select
                separateLabel
                options={companyList ? companyList : []}
                label={t("HPI.Profilepage.myprofile.Accountname", {
                  defaultValue: "Account name",
                })}
                placement="bottom"
                required
                placeholder={t("HPI.Dropdown.SelectAccount", {
                  defaultValue: "Select Account",
                })}
                helperTextVisibility="auto"
                name="parentCustomerId"
                clearIcon={false}
                error={errorState["parentCustomerId"] ? true : false}
                helperText={errorState["parentCustomerId"] || ""}
                onChange={(selectedOption: any) => {
                  handleSelectChange(selectedOption, "parentCustomerId");
                }}
                value={[formState["parentCustomerId"]]} // || userObj?.accountType}
              />
            </Col>
        {formState["parentCustomerId"] !== '-1' ? 
            <Col md={6}>
            <Select
              options={bindPinList?bindPinList:[]}
              showSearch
              label={t("HPI.CreateCase.Pin",{defaultValue:'Pin'})}
              helperTextVisibility="auto"
              separateLabel
              name="updatedPinId"
              placeholder={t('HPI.PIN',{defaultValue:'Select Pin'})}
              onSearch={(value: any) => {
                  let filtered: any = onSearchDropDown(pinList, value);
                  setBindPinList(filtered);
                }}
                value={[formState["pinId"]]}

              onChange={(selectedOption: any) => {
                handleSelectChange(selectedOption, "updatedPinId");
              }}
              
              // onClear={() => {selectPinClearHandler()}}
              clearIcon={false}
              error={errorState["updatedPinId"] ? true : false}
              helperText={errorState["updatedPinId"] || ""}
              className="textbox"
          />
            </Col> : "" }
            </>

          ) : (
            ""
          )}

          <Col col={12} md={6} className="textbox">
            <Select
              separateLabel
              options={languageList ? languageList : []} //portalLanguageId
              label={t("HPI.Profilepage.myprofile.PreferredDisplayLanguage", {
                defaultValue: "Preferred page display language",
              })}
              required
              placeholder={t("HPI.Dropdown.LanguageSelection", {
                defaultValue: "Select Language",
              })}
              placement="bottom"
              helperTextVisibility="auto"
              name="portalLanguageId"
              clearIcon={false}
              error={errorState["portalLanguageId"] ? true : false}
              helperText={errorState["portalLanguageId"] || ""}
              onChange={(selectedOption: any) => {
                handleSelectChange(selectedOption, "portalLanguageId");
              }}
              value={formState ? [formState["portalLanguageId"]] : []} // || userObj?.timezonename}
            //value={[formState["portalLanguageId"]] }// || userObj?.portalLanguageId}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Select
              options={timeZoneList ? timeZoneList : []}
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Timezone", {
                defaultValue: "Time zone",
              })}
              placeholder={t("HPI.ProfilePage.js.SelectTimezone", {
                defaultValue: "Please select",
              })}
              required
              className="textbox"
              separateLabel
              name="timezonename"
              clearIcon={false}
              error={errorState["timezonename"] ? true : false}
              helperText={errorState["timezonename"] || ""}
              onChange={(selectedOption: any) => {
                handleSelectChange(selectedOption, "timezonename");
              }}
              value={formState ? [formState["timeZone"]] : []} // || userObj?.timezonename}
            />
          </Col>

        </Row>
        <Row>
          <Col className="heading-container mt-4 mb-4">
            <h6 className="subtitle-regular">
              {t("HPI.Profilepage.myprofile.Address", {
                defaultValue: "Address",
              })}
            </h6>
            <p>
              {t("HPI.Profilepage.myprofile.Address.Notes", {
                defaultValue:
                  "Please provide your address. If this is a company account, provide the address for office headquarters.",
              })}
            </p>
          </Col>
        </Row>
        <Row>
          <Col col={12} md={6}>
            <TextBox
              defaultValue=""
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Address.Mailstop", {
                defaultValue: "Mail stop",
              })}
              placeholder={t("HPI.Profilepage.Placeholder.EnterMailStop", {
                defaultValue: "Enter mail stop",
              })}
              className="textbox"
              separateLabel
              name="mailstop"
              onChange={(v: any, e) => {
                handleChange(v, e);
              }}
              value={formState?.["mailstop"]} // || userObj?.mailstop}
            />
          </Col>
        </Row>

        <Row>
          <Col col={12} md={4}>
            <TextBox
              defaultValue=""
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Address.Addressline1", {
                defaultValue: "Address line 1",
              })}
              placeholder={t("HPI.Profilepage.Placeholder.EnterAddressLine1", {
                defaultValue: "Enter address line 1",
              })}
              required
              className="textbox"
              separateLabel
              name="addressline1"
              error={errorState["addressline1"] ? true : false}
              helperText={errorState["addressline1"] || ""}
              onChange={(v: any, e) => {
                handleChange(v, e);
              }}
              value={formState["addressline1"]} // || userObj?.addressline1}
            />
          </Col>

          <Col col={12} md={4}>
            <TextBox
              defaultValue=""
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Address.Addressline2", {
                defaultValue: "Address line 2",
              })}
              placeholder={t("HPI.Profilepage.Placeholder.EnterAddressLine2", {
                defaultValue: "Enter address line 2",
              })}
              className="textbox"
              separateLabel
              name="addressline2"
              error={errorState["addressline2"] ? true : false}
              helperText={errorState["addressline2"] || ""}
              onChange={(v: any, e) => {
                handleChange(v, e);
                if (v === "") {
                  setErrorState((prevState) => ({
                    ...prevState,
                    ["addressline2"]: '',
                  }));
                }
              }}
              value={formState?.addressline2}
            />
          </Col>
          <Col col={12} md={4}>
            <TextBox
              defaultValue=""
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Address.Addressline3", {
                defaultValue: "Address line 3",
              })}
              placeholder={t("HPI.Profilepage.Placeholder.EnterAddressLine3", {
                defaultValue: "Enter address line 3",
              })}
              //required
              className="textbox"
              separateLabel
              name="addressline3"
              error={errorState["addressline3"] ? true : false}
              helperText={errorState["addressline3"] || ""}
              onChange={(v: any, e) => {
                handleChange(v, e);
                if (v === "") {
                  setErrorState((prevState) => ({
                    ...prevState,
                    ["addressline3"]: '',
                  }));
                }
              }}
              value={formState?.addressline3} // || userObj?.addressline3}
            />
          </Col>
        </Row>
        <Row>
          <Col col={12} md={4}>
            <TextBox
              defaultValue=""
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Address.CityTown", {
                defaultValue: "City/Town",
              })}
              placeholder={t("HPI.Profilepage.Placeholder.EnterCity/Town", {
                defaultValue: "Enter city/town",
              })}
              required
              className="textbox"
              name="phCity"
              error={errorState["phCity"] ? true : false}
              helperText={errorState["phCity"] || ""}
              separateLabel
              onChange={(v: any, e) => {
                handleChange(v, e);
              }}
              value={formState["phCity"]} // || userObj?.phCity}
            />
          </Col>

          <Col col={12} md={4}>
            <TextBox
              defaultValue=""
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Address.StateProvince", {
                defaultValue: "State/Province",
              })}
              placeholder={t(
                "HPI.Profilepage.Placeholder.EnterState/Province",
                { defaultValue: "Enter state/province" }
              )}
              required
              className="textbox"
              separateLabel
              name="phState"
              error={errorState["phState"] ? true : false}
              helperText={errorState["phState"] || ""}
              onChange={(v: any, e) => {
                handleChange(v, e);
              }}
              value={formState["phState"]} // || userObj?.phState}
            />
          </Col>
          <Col col={12} md={4}>
            <TextBox
              defaultValue=""
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Address.ZipcodePostalcode", {
                defaultValue: "Zip code/Postal code",
              })}
              placeholder={t(
                "HPI.Profilepage.Placeholder.EnterZip/PostalCode",
                { defaultValue: "Enter zip/postal code" }
              )}
              required
              className="textbox"
              separateLabel
              name="phZipcode"
              error={errorState["phZipcode"] ? true : false}
              helperText={errorState["phZipcode"] || ""}
              onChange={(v: any, e) => {
                handleChange(v, e);
              }}
              value={formState["phZipcode"]} // || userObj?.phZipcode}
            />
          </Col>
        </Row>

        <Row>
          <Col col={12} md={4}>
            <Select
              options={filteredCountryList || []} //portalLanguageId
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Address.CountryRegion", {
                defaultValue: "Country/Region",
              })}
              placeholder={t(
                "HPI.CreateCase.Placeholder.EnterCountry/Region",
                { defaultValue: "Select country/region" }
              )} //
              required
              className="textbox"
              separateLabel
              name="countryId"
              
              error={errorState["countryId"] ? true : false}
              helperText={errorState["countryId"] || ""}
              onChange={(selectedOption: any) => {
                handleSelectChange(selectedOption, "countryId");
                handleContryLogic(selectedOption);
              }}
              showSearch
              onSearch={(value: any) => {
                let filtered: any = onSearchDropDown(countryList, value);
                setFilteredCountryList(filtered);
              }}
              value={[formState["countryId"]]} // || userObj?.countryId}
              onClear={() => {
                  setFormState((prevState) => ({
                    ...prevState,
                    ["phoneNmCountryCode"]: "",
                    ["countryId"]: "",
                  }));
                }}
            />
          </Col>
          <Col col={12} md={6}>
            <Select
              options={filteredLanguage ? filteredLanguage : []} //portalLanguageId
              //helperText="Helper Text"
              label={t("HPI.Profilepage.myprofile.Preferredlanguage", {
                defaultValue: "Preferred communication language",
              })}
              placeholder={t("HPI.Profilepage.myprofile.Preferredlanguage", {
                defaultValue: "Preferred communication language",
              })}
              required
              className="textbox"
              separateLabel
              name="languageId"
              clearIcon={false}
              error={errorState["languageId"] ? true : false}
              helperText={errorState["languageId"] || ""}
              onChange={(selectedOption: any) => {
                handleSelectChange(selectedOption, "languageId");
              }}
              value={[formState["languageId"]]} // || userObj?.countryId}
            />
          </Col>
        </Row>

        <Row>
          <Col col={12} className="mt-3 mb-3">
            <div className="input-container">
              <div className="tooltip-container">
                <div className="label-container">
                  <label>  {t("HPI.Profilepage.myprofile.Address.EmailNotify", {
                    defaultValue:
                      "Receive email notifications on case and order updates?",
                  })}
                    {/* <span className="error">*</span> */}
                  </label>
                  <span className="supporting-text">
                    <HelpModalPopup
                      align={"start"}
                      id={"modal-popup"}
                      show={open}
                      onClose={() => setOpen(false)}
                      title={popupHeader()}
                      callback={() => handleCallBack(t("Opt in/Opt out Header", { defaultValue: 'Opt in / Opt out' }))}
                    >
                      <p>
                        {t("Opt in/Opt out tooltip", { defaultValue: "HP occasionally communicates information that may interest you (product, service, support information, special offers, or market research invitations)." })}
                      </p>
                    </HelpModalPopup>
                  </span>
                </div>
              </div>

            </div>
            <div>
              {userObj?.optInOptOut !== undefined && (
                <RadioGroup
                  alignment="vertical"
                  id="email-Notification"
                  name="optInOptOut"
                  defaultValue={userObj?.optInOptOut === "true" ? "1" : "0"}
                  onChange={(e) => {
                    let radioValue = e.target.value === "1" ? true : false;
                    setOptInOptOut(radioValue);
                  }}
                >
                  <RadioButton
                    id="opt-in"
                    value="1"
                    label={t("HPI.Option.OptIn", { defaultValue: "Opt in" })}
                  />
                  <RadioButton
                    id="opt-out"
                    value="0"
                    label={t("HPI.Option.OptOut", { defaultValue: "Opt out" })}
                  />
                </RadioGroup>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col col={12} className="mt-3 mb-3" dangerouslySetInnerHTML={{ __html: t('HpPrivacyStatementLink', { defaultValue: `<p>By completing and submitting this form you consent to the use of your data in accordance with HP's Privacy statement.&nbsp;<a target=\"_blank\" href=\"http://www8.hp.com/us/en/privacy/privacy.html\">Learn more about HP's privacy policy</a></p>` }) }}>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end mt-4">
            <div className="button-conatiner">
              <Button type="submit">
                {t("HPI.Save", { defaultValue: "Save" })}
              </Button>
              <Button
                style={{ marginLeft: "20px" }}
                onClick={handleViewProfile}
              >
                {t("HPI.Profilepage.myprofile.Viewprofile", {
                  defaultValue: "View profile",
                })}
              </Button>
              <ViewProfile
                onClose={closePopup}
                show={openPopup}
                profileData={userData}
              />
            </div>
          </Col>
        </Row>
      </form>
    </div>
  );
};
